(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-delivery-modal"] && !window.DesignMode) return;
  try {
    
  var A11yDialog = window.A11yDialog;
  const container = document.querySelector('#delivery-dialog');
  const dialog = new A11yDialog(container);
  console.log('dialog:', dialog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // sticky header
  var prevScrollpos = window.pageYOffset;
  var aph_bar_bar = null;
  window.onscroll = function () {
    // Check for Attrac announcement bar and it's css position style to properly position header nav show/hide...
    if (!aph_bar_bar) {
      aph_bar_bar = document.querySelector('.aph_bar_bar');
      if (aph_bar_bar) {
        const computedStyles = getComputedStyle(aph_bar_bar);
        const position = computedStyles.position;
        const isSticky = aph_bar_bar && position !== 'relative';
        console.log('isSticky:', isSticky, position);
        isSticky && document.body.classList.add('has-aph-bar');
      } else {
        document.body.classList.remove('has-aph-bar');
      }
    }
    var currentScrollPos = window.pageYOffset;

    // Add header-top class when window viewport is at top of page...
    if (currentScrollPos > 100) {
      document.querySelector('.section-header').classList.remove('header--top');
    } else {
      document.querySelector('.section-header').classList.add('header--top');
    }

    // hide and show based on scroll direction...
    if (prevScrollpos > currentScrollPos) {
      document.querySelector('.section-header').classList.remove('hide');
    } else {
      document.querySelector('.section-header').classList.add('hide');
    }
    prevScrollpos = currentScrollPos;
  };

  } catch(e) { console.error(e); }
})();
})();
